
import Allocation from './allocation/Allocation.vue';

if (document.querySelector('#allocation')) {
    const allocationElem = document.querySelector('#allocation');
    const allocationElemData = JSON.parse(allocationElem.dataset.allocations);
    var app = new Vue({
        el: '#allocation',
        template: '<Allocation :allocationData="allocationData"/>',
        data(){
          return {
              allocationData: allocationElemData
          }
        },
        created() {
            window.vue = this;
        },
        mounted() {
        },
        components: {Allocation},
    });
}